document.addEventListener('DOMContentLoaded', function () {
    const collections = document.querySelectorAll('.collection-item');
    const textLinks = document.querySelectorAll('.collection-text-link');
    const categoryButtons = document.querySelectorAll('.category-btn');
    const letterButtons = document.querySelectorAll('.az-btn');
    const searchInput = document.getElementById('collectionSearch');

    let selectedCategory = 'all';
    let selectedLetter = 'all';
    let searchKeyword = '';

    function normalize(str) {
      return str.toLowerCase().trim();
    }

    function filterCollections() {
      collections.forEach((item) => {
        const itemCategories = item.dataset.categories?.toLowerCase() || '';
        const itemLetter = item.dataset.title?.toLowerCase() || '';
        const itemText = item.innerText.toLowerCase();

        const matchCategory = selectedCategory === 'all' || itemCategories.includes(normalize(selectedCategory));
        const matchLetter = selectedLetter === 'all' || itemLetter === normalize(selectedLetter);
        const matchSearch = !searchKeyword || itemText.includes(normalize(searchKeyword));

        item.style.display = matchCategory && matchLetter && matchSearch ? 'block' : 'none';
      });

      textLinks.forEach((link) => {
        const linkCategories = link.dataset.categories?.toLowerCase() || '';
        const linkLetter = link.dataset.title?.toLowerCase() || '';
        const linkText = link.innerText.toLowerCase();

        const matchCategory = selectedCategory === 'all' || linkCategories.includes(normalize(selectedCategory));
        const matchLetter = selectedLetter === 'all' || linkLetter === normalize(selectedLetter);
        const matchSearch = !searchKeyword || linkText.includes(normalize(searchKeyword));

        link.style.display = matchCategory && matchLetter && matchSearch ? 'block' : 'none';
      });
    }

    categoryButtons.forEach((btn) => {
      btn.addEventListener('click', function () {
        categoryButtons.forEach((b) => b.classList.remove('current'));
        this.classList.add('current');
        selectedCategory = this.dataset.category;
        filterCollections();
      });
    });

    letterButtons.forEach((btn) => {
      btn.addEventListener('click', function () {
        letterButtons.forEach((b) => b.classList.remove('current'));
        this.classList.add('current');
        selectedLetter = this.dataset.letter;
        filterCollections();
      });
    });

    searchInput.addEventListener('input', function () {
      searchKeyword = this.value;
      filterCollections();
    });

    filterCollections();
  });


document.addEventListener('DOMContentLoaded', function () {
    const scrollContainer = document.getElementById('categoryListScroll');
    const scrollNextCat = document.getElementById('scrollNextCategory');

    scrollNextCat?.addEventListener('click', function () {
      scrollContainer.scrollBy({ left: 300, behavior: 'smooth' });
    });
});

//main category scroll arrows
document.addEventListener("DOMContentLoaded", function () {
  const scrollContainer = document.getElementById("categoryListScroll");
  const scrollNext = document.getElementById("scrollNextCategory");
  const scrollPrev = document.getElementById("scrollPrevCategory");

function checkArrowVisibility() {
  const scrollLeft = scrollContainer.scrollLeft;
  const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;

  // Prev arrow
  if (scrollLeft > 0) {
    scrollPrev.classList.add("visible");
    scrollPrev.classList.remove("hidden");
  } else {
    scrollPrev.classList.add("hidden");
    scrollPrev.classList.remove("visible");
  }

  // Next arrow
  if (scrollLeft < maxScrollLeft - 1) { // -1 for float accuracy
    scrollNext.classList.add("visible");
    scrollNext.classList.remove("hidden");
  } else {
    scrollNext.classList.add("hidden");
    scrollNext.classList.remove("visible");
  }
}

scrollContainer.addEventListener("scroll", () => {
  checkArrowVisibility();
});

window.addEventListener("resize", () => {
  checkArrowVisibility();
});

checkArrowVisibility();

  scrollPrev?.addEventListener("click", () => {
    scrollContainer.scrollBy({ left: -300, behavior: "smooth" });
  });

  scrollNext?.addEventListener("click", () => {
    scrollContainer.scrollBy({ left: 300, behavior: "smooth" });
  });
});

//text list scroll arrows
document.addEventListener("DOMContentLoaded", function () {
  const scrollContainer = document.getElementById("textListScroll");
  const thumb = document.getElementById("scrollbarThumb");
  const track = document.querySelector(".scrollbar-fake-track");
  const scrollNext = document.getElementById("scrollNext");
  const scrollPrev = document.getElementById("scrollPrev");

function checkArrowVisibility() {
  const scrollLeft = scrollContainer.scrollLeft;
  const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;

  // Prev arrow
  if (scrollLeft > 0) {
    scrollPrev.classList.add("visible");
    scrollPrev.classList.remove("hidden");
  } else {
    scrollPrev.classList.add("hidden");
    scrollPrev.classList.remove("visible");
  }

  // Next arrow
  if (scrollLeft < maxScrollLeft - 1) { // -1 for float accuracy
    scrollNext.classList.add("visible");
    scrollNext.classList.remove("hidden");
  } else {
    scrollNext.classList.add("hidden");
    scrollNext.classList.remove("visible");
  }
}

  function updateThumb() {
    const scrollWidth = scrollContainer.scrollWidth;
    const clientWidth = scrollContainer.clientWidth;
    const scrollLeft = scrollContainer.scrollLeft;
    const trackWidth = track.clientWidth;

    const thumbWidth = (clientWidth / scrollWidth) * trackWidth;
    const thumbLeft = (scrollLeft / scrollWidth) * trackWidth;

    thumb.style.width = `${thumbWidth}px`;
    thumb.style.left = `${thumbLeft}px`;
  }

scrollContainer.addEventListener("scroll", () => {
  updateThumb();
  checkArrowVisibility();
});

window.addEventListener("resize", () => {
  updateThumb();
  checkArrowVisibility();
});

  updateThumb();
checkArrowVisibility();

  scrollPrev?.addEventListener("click", () => {
    scrollContainer.scrollBy({ left: -300, behavior: "smooth" });
  });

  scrollNext?.addEventListener("click", () => {
    scrollContainer.scrollBy({ left: 300, behavior: "smooth" });
  });

  // === Dragging the fake scrollbar thumb ===

  let isDragging = false;
  let startX = 0;
  let scrollStart = 0;
  let deltaX = 0;

  let isScrolling = false;

  function animateScroll() {
    if (!isDragging) return;
    const scrollWidth = scrollContainer.scrollWidth;
    const trackWidth = track.clientWidth;
    const scrollAmount = (deltaX / trackWidth) * scrollWidth;
    scrollContainer.scrollLeft = scrollStart + scrollAmount;

    requestAnimationFrame(animateScroll);
  }

  thumb.addEventListener("mousedown", (e) => {
    isDragging = true;
    startX = e.pageX;
    scrollStart = scrollContainer.scrollLeft;
    deltaX = 0;
    document.body.style.userSelect = "none";
    requestAnimationFrame(animateScroll);
  });

  document.addEventListener("mousemove", (e) => {
    if (!isDragging) return;
    deltaX = e.pageX - startX;
  });

  document.addEventListener("mouseup", () => {
    isDragging = false;
    document.body.style.userSelect = "";
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector(".section-list-collections");
  if (!section) return;

  const EPS = 12; // row tolerance (px)

  const getWrappers = () =>
    [...section.querySelectorAll(".collection-card-picture")]
      .filter(el => el.offsetParent !== null);

  // Detect columns by counting items that are on the first row
  function detectColumns(wrappers) {
    if (!wrappers.length) return 1;
    const top0 = wrappers[0].getBoundingClientRect().top;
    let cols = 0;
    for (const w of wrappers) {
      const t = w.getBoundingClientRect().top;
      if (Math.abs(t - top0) <= EPS) cols++; else break;
    }
    return Math.max(cols, 1);
  }

  const chunk = (arr, n) => {
    const out = [];
    for (let i = 0; i < arr.length; i += n) out.push(arr.slice(i, i + n));
    return out;
  };

  function equalizeAdaptive() {
    const wrappers = getWrappers();
    wrappers.forEach(w => w.style.height = "auto"); // reset

    const cols = detectColumns(wrappers); // 1 on single‑column, 2 on 390px, 3 on desktop, etc.
    if (cols <= 1) return; // nothing to equalize

    chunk(wrappers, cols).forEach(group => {
      let maxH = 0;
      group.forEach(w => maxH = Math.max(maxH, w.offsetHeight));
      group.forEach(w => w.style.height = maxH + "px");
    });
  }

  // Run after images & fonts
  function afterImagesAndFonts(cb) {
    const imgs = section.querySelectorAll(".collection-card-picture img");
    let pending = imgs.length;
    const run = () => (document.fonts?.ready ? document.fonts.ready.then(cb) : cb());
    if (!pending) return run();
    imgs.forEach(img => {
      const done = () => { if (--pending === 0) run(); };
      img.complete ? done() : (img.addEventListener("load", done, {once:true}), img.addEventListener("error", done, {once:true}));
    });
  }
  afterImagesAndFonts(equalizeAdaptive);

  // Re-run when images resize, on resize, and on DOM mutations
  const ro = new ResizeObserver(() => { clearTimeout(window.__eqRO); window.__eqRO = setTimeout(equalizeAdaptive, 50); });
  section.querySelectorAll(".collection-card-picture img").forEach(img => ro.observe(img));
  window.addEventListener("resize", () => { clearTimeout(window.__eqWin); window.__eqWin = setTimeout(equalizeAdaptive, 80); });
  const mo = new MutationObserver(() => { clearTimeout(window.__eqMut); window.__eqMut = setTimeout(equalizeAdaptive, 50); });
  mo.observe(section, { childList: true, subtree: true });
});

(function () {
  function normalize(s) {
    return (s || "")
      .toString()
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/\s+/g, " ")
      .trim()
      .replace(/[^a-z0-9]+/g, "-");
  }

  function requestedCategory() {
    const params = new URLSearchParams(window.location.search);
    return params.get("category") || (window.location.hash || "").slice(1);
  }

  function activateFromLink() {
    const raw = decodeURIComponent(requestedCategory() || "");
    if (!raw) return;

    const wanted = normalize(raw);
    const buttons = document.querySelectorAll("#categoryListScroll [data-category]");
    if (!buttons.length) return;

    let target = null;
    for (const btn of buttons) {
      const byData = normalize(btn.getAttribute("data-category"));
      const byText = normalize(btn.textContent || "");
      if (byData === wanted || byText === wanted) {
        target = btn;
        break;
      }
    }
    if (target) {
      target.click();                     // trigger your existing filter logic
      target.scrollIntoView({ inline: "center", block: "nearest" });
    }
  }

  // Wait for buttons to exist (covers async section loads)
  function whenReady(run) {
    if (document.querySelector("#categoryListScroll [data-category]")) return run();
    const mo = new MutationObserver(() => {
      if (document.querySelector("#categoryListScroll [data-category]")) {
        mo.disconnect();
        run();
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", () => whenReady(activateFromLink));
  document.addEventListener("shopify:section:load", activateFromLink);
})();